import Navbar from "./components/Navbar"
import bgheader from "./assets/header-bg.png"
import HeroSection from "./components/HeroSection";
import FlappyBase from "./components/FlappyBase";
import PreSale from "./components/PreSale";
import Reffer from "./components/Reffer";
import Roadmap from "./components/Roadmap";
import EarlyAcees from "./components/EarlyAcees";
import FrequentQuestion from "./components/FrequentQuestion";
import Footer from "./components/Footer";

function App() {
  return (
    <>
    <div className="w-screen flex items-center justify-center flex-col bg-black">
    <div className="h-full md:w-[1442px] w-full bg-cover bg-no-repeat py-10 pb-24 header" style={{
      backgroundImage: `url(${bgheader})`,
      backgroundPosition: 'center'
    }}>
      <Navbar />
      <HeroSection />
    </div>
    <FlappyBase />
    <PreSale />
    <Reffer />
    <Roadmap />
    <EarlyAcees />
    <FrequentQuestion />
    <Footer />
    </div>
    </>
  );
}

export default App;
